import React from "react";
import debug from "debug";
import { Observer } from "mobx-react";
import { Field, FormStore } from "../formx";
import { FormContext, FormContextType } from "./FormContext";
import { FieldOptions } from "../formx/types";

export { FieldOptions };

type Props = {
  name: string;
  children: (field: Field<any>, store: FormStore<any>) => React.ReactElement<any>;
  fieldOptions?: FieldOptions<any>;
};

export class FormField extends React.Component<Props> {
  static contextType = FormContext;
  context!: React.ContextType<typeof FormContext>;

  name: string;
  field: Field<any>;
  log: debug.IDebugger;

  constructor(props: Props, context: FormContextType) {
    super(props);

    if (!context || !context.store) {
      throw new Error("missing context. FormField should be nested within FormX");
    }

    this.name = props.name;
    this.field = context.store.registerField(props.name, this.props.fieldOptions);
    this.log = debug(`FormXReact:FormField:${props.name}`);
  }

  shouldComponentUpdate(nextProps: Props) {
    if (nextProps.name !== this.name) {
      throw new Error("name property is immutable");
    }

    return true;
  }

  componentWillUnmount() {
    this.context.store.unregisterField(this.name);
  }

  render() {
    this.log("render");

    const { children } = this.props;

    return <Observer>{() => children(this.field, this.context.store)}</Observer>;
  }
}

export default FormField;
